/**
 * How a list filter is spelt in the address bar, a saved view and the list
 * query — one spelling for all three (BILL-023).
 *
 * The document number is the `q` search and the document date the `from`/`to`
 * range, as they always were. Any other text filter — a supplier's invoice
 * number — is its own parameter, matched as "contains"; any other date range
 * — the payment due date — is `<key>From` / `<key>To`. They used to be read
 * as a second document-number search and a second document-date range.
 */
import type { FilterDef } from './types.js'

export const isNumberSearch = (f: Pick<FilterDef, 'key' | 'control'>): boolean =>
  f.control === 'text' && f.key === 'documentNo'

export const isDocumentDateRange = (f: Pick<FilterDef, 'key' | 'control'>): boolean =>
  f.control === 'dateRange' && f.key === 'documentDate'

/** The parameter(s) one filter travels as. */
export const filterParamKeys = (f: Pick<FilterDef, 'key' | 'control'>): string[] => {
  if (f.control === 'status') return ['status']
  if (isNumberSearch(f)) return ['q']
  if (f.control === 'dateRange') return isDocumentDateRange(f) ? ['from', 'to'] : [`${f.key}From`, `${f.key}To`]
  return [f.key]
}
